import React from 'react';

interface GoogleMapProps {
  address: string;
  apiKey?: string;
}

const GoogleMap: React.FC<GoogleMapProps> = ({ address, apiKey }) => {
  // Encode the address for use in the URL
  const encodedAddress = encodeURIComponent(address);
  
  // If API key is provided, use it for the map
  const mapSrc = apiKey 
    ? `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodedAddress}&zoom=15` 
    : `https://maps.google.com/maps?q=${encodedAddress}&t=m&z=15&output=embed&iwloc=near`;

  return (
    <div className="w-full h-full min-h-[300px] rounded-lg overflow-hidden shadow-lg">
      <iframe
        title="Google Maps"
        src={mapSrc}
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: '300px' }}
        allowFullScreen={true}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default GoogleMap;
